import { render, staticRenderFns } from "./HoritzontalScrollable.vue?vue&type=template&id=e896fcd0"
import script from "./HoritzontalScrollable.vue?vue&type=script&lang=js"
export * from "./HoritzontalScrollable.vue?vue&type=script&lang=js"
import style0 from "./HoritzontalScrollable.vue?vue&type=style&index=0&id=e896fcd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports